export default __webpack_public_path__ + "static/media/lopetus.425515fe.png";